var map = {
	"./ACU/Hero": [
		65971,
		408
	],
	"./Adelaide/Hero": [
		15701,
		7160
	],
	"./CQU/Hero": [
		90811,
		3516
	],
	"./Deakin/Hero": [
		83444,
		8955
	],
	"./JCU/Hero": [
		10858,
		2999
	],
	"./MacEwan/Hero": [
		84604,
		5141
	],
	"./Monash/Hero": [
		39150,
		3193
	],
	"./Nanyang/Hero": [
		49796,
		6285,
		3157
	],
	"./Purdue/Hero": [
		19167,
		6346
	],
	"./QUT/Hero": [
		26158,
		9319
	],
	"./RMIT/Hero": [
		99572,
		1423
	],
	"./Sydney/Hero": [
		49736,
		6947
	],
	"./UC/Hero": [
		50836,
		4411
	],
	"./UTM/Hero": [
		3348,
		6473
	],
	"./UTS/Hero": [
		98618,
		5959
	],
	"./UWA/Hero": [
		55111,
		6276
	],
	"./UWS/Hero": [
		43273,
		4758
	],
	"./UniSA/Hero": [
		58142,
		6151
	],
	"./VU/Hero": [
		11045,
		8332
	],
	"./demo/Hero": [
		34043,
		2594
	],
	"./demous/Hero": [
		46435,
		6074
	],
	"./future/Hero": [
		16243,
		5282
	],
	"./glos/Hero": [
		84813,
		4848
	],
	"./gordon/Hero": [
		40078,
		6552
	],
	"./local/Hero": [
		88903,
		1176
	],
	"./staging/Hero": [
		82497,
		9794
	],
	"./staging5v11/Hero": [
		66684,
		7373
	],
	"./staging5v12/Hero": [
		82597,
		6374
	],
	"./staging5v13/Hero": [
		58398,
		767
	],
	"./staging5v14/Hero": [
		92959,
		1744
	],
	"./staging5v15/Hero": [
		61848,
		4553
	],
	"./staging5v16/Hero": [
		45169,
		7362
	],
	"./staging5v16codefreeze/Hero": [
		36743,
		468
	],
	"./staging5v16regression/Hero": [
		67980,
		3765
	],
	"./stagingQUT/Hero": [
		84017,
		4900
	],
	"./utsc/Hero": [
		76787,
		4958
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34122;
module.exports = webpackAsyncContext;